// src/components/Hero.jsx
import React from 'react';
import { Button } from './Button';

export function Hero() {
  return (
    <section className="bg-gradient-to-r from-primary to-primary-dark text-white py-2 text-center">
      <h1 className="text-3xl font-semibold mb-2">Get Expert Help Today</h1>
      <div className="flex justify-center space-x-4">
        <Button href="/schedule.html">Schedule a Call</Button>
        <Button href="/contact.html">Contact Us</Button>
        <Button href="/presentations.html">View Presentations</Button>
      </div>
    </section>
  );
}
